import React from 'react'

import SVGLoader from './SVGLoader'

import './SubMenu.scss'

const onClick = function (event, toggleSelecionaItemMenu) {
    // event.preventDefault ()
    // event.stopPropagation()

    const menu = document.querySelector('.menuFlutuante')
    const itensAbertos = menu.querySelectorAll('.is-open')
    const menuScroll = menu.querySelector('#menuList')

    itensAbertos.forEach(aberto => (aberto !== event.target ? aberto.classList.toggle('is-open') : () => {}))
    event.target.classList.toggle('is-open')

    menuScroll.scrollTo({ top: 0, behavior: 'smooth' })

    toggleSelecionaItemMenu()
}

export default function SubMenu(props) {
    return (
        <li className={`transparencia-sub-menu ${props.className || ''}`} onClick={e => onClick(e, props.toggleSelecionaItemMenu)}>
            <SVGLoader className="imagemItemMenu" imagem={`icones/${props.imagem || 'settings.svg'}`} fallback="icones/settings.svg" />
            <button name="submenu" className="submenu">
                {props.titulo}
            </button>
            <ul>
                <SVGLoader className="imagemItemMenuFundo" imagem={`icones/${props.imagem || 'settings.svg'}`} fallback="icones/settings.svg" />
                <div className="tituloSubmenu">
                    <SVGLoader
                        className="imagemItemMenu imagemItemMenuTitulo"
                        imagem={`icones/${props.imagem || 'settings.svg'}`}
                        fallback="icones/settings.svg"
                    />
                    {props.titulo}
                </div>
                {props.conteudo}
            </ul>
        </li>
    )
}
